import { render, staticRenderFns } from "./attach-quote.vue?vue&type=template&id=54b76325&scoped=true&"
import script from "./attach-quote.vue?vue&type=script&lang=js&"
export * from "./attach-quote.vue?vue&type=script&lang=js&"
import style0 from "./attach-quote.vue?vue&type=style&index=0&id=54b76325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b76325",
  null
  
)

export default component.exports